module.exports = __webpack_public_path__ + "img/incubator-placeholder.6f12755e.png";